import React, { useEffect, useState } from 'react';
import styles from './privacy.module.scss';
import { Button } from 'antd-mobile-v5';
import  { ApiCore } from '../../../api/index';
import utils from '../../../utils/utils';

const api = new ApiCore();
function Privacy(props: any) {

    const [showUserPrivacyText, setShowUserPrivacyText] = useState(true);
    const [activeAgreeTab, setActiveAgreeTab] = useState('left');
    const [showPrivacy, setShowPrivacy] = useState(true);

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])


    const initData = () => {
        const urlParms = utils.getUrlParams();
        if (urlParms.tab === 'user') {
            setActiveAgreeTab('left');
            document.title = '用户协议';
        } else {
            setActiveAgreeTab('right');
            document.title = '隐私协议';
        }
    }

    const agreeTabChange = (type: string) => {
        setActiveAgreeTab(type);
    }

    const agree = () => {
        localStorage.setItem('alk_privacy_readed', 'true');
        setShowPrivacy(false);
    }

    return (
        <div className={`${styles.privacy_content}`} style={{ display: showPrivacy ? '' : 'none'}}>
            <div className={`${styles.agree_wrap} ${styles.aggreement}`}>
                {
                    activeAgreeTab === 'left' ?
                    <div className={`${styles.aggreement_content}`}>
                    <div className={`${styles.section}`}>
                        <div className={`${styles.title} ${styles.no_indent}`}>
                            ALK患者关爱之家用户服务协议
                        </div>
                        <div className={`${styles.item}`}>
                            欢迎您使用ALK患者关爱之家的服务！
                        </div>
                        <div className={`${styles.item}`}>
                            为使用ALK患者关爱之家的服务，您应当阅读并遵守本《ALK患者关爱之家用户服务协议》（以下简称“本协议”）。本协议是用户与ALK患者关爱之家之间的法律协议，是用户注册ALK患者关爱之家账号并使用ALK患者关爱之家平台服务或非经注册程序直接使用ALK患者关爱之家平台服务时的通用条款。请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。限制、免责条款可能以黑体加粗或加下划线的形式提示您重点注意。如果您不同意本协议的约定，您应立即停止使用ALK患者关爱之家平台服务；如您继续访问和使用ALK患者关爱之家平台服务，即视为您已确知并完全同意本协议各项约定。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        一、定义
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.ALK患者关爱之家平台，是惠每数科(北京)医疗科技有限公司旗下致力于做患者新药服务业务，ALK患者关爱之家平台系专注于为用户提供医学量表、病情风险评估、定期推送前沿医学研究进展、医疗科普以及其他医学资讯的互联网平台。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.用户，以下亦称为“您”，系指注册或登录ALK患者关爱之家平台使用ALK患者关爱之家产品或服务的具有完全民事权利能力和行为能力的企业法人、社会团体、自然人或其他社会组织等。按用户是否经过注册程序分为注册用户和非注册用户，注册用户是指通过ALK患者关爱之家平台完成全部注册程序后，使用ALK患者关爱之家平台服务的用户。非注册用户是指未进行注册、直接登录ALK患者关爱之家平台或通过其他ALK患者关爱之家平台允许的方式进入ALK患者关爱之家平台直接或间接地使用ALK患者关爱之家平台服务或ALK患者关爱之家网站资料的用户。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.协议方，本协议中的协议方包括ALK患者关爱之家平台运营方以及为ALK患者关爱之家平台提供技术服务、咨询服务的关联方作为一方，统称“ALK患者关爱之家”，您作为另一方。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        二、协议的效力
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.在您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后或以其他ALK患者关爱之家允许的方式实际使用ALK患者关爱之家平台服务时，您即受本协议的约束。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.本协议内容包括本协议正文，您在使用ALK患者关爱之家某一特定服务或系统时，该服务可能会另有单独的协议、相关业务规则、公告、帮助、说明、通用条款等（以下统称为“规则”）。所有ALK患者关爱之家已经发布的或将来可能发布的规则均为本协议不可分割的组成部分，与本协议具有同等法律效力。除另行明确声明外，任何ALK患者关爱之家及其关联公司提供的服务（以下称为“ALK患者关爱之家平台服务”）均受本协议约束。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用ALK患者关爱之家平台服务；如您继续访问和使用ALK患者关爱之家平台服务，即视为您已确知并完全同意本协议各项内容。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        三、注册
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.您确认，在您完成注册程序或以其他ALK患者关爱之家允许的方式实际使用ALK患者关爱之家平台服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的家长或法定监护人（以下统称＂监护人”）应承担因此而导致的一切后果，且ALK患者关爱之家有权注销您的账户，并向您及您的监护人索偿。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.ALK患者关爱之家非常重视对青少年个人信息搜集和使用的安全性的保护。任何未满18周岁的未成年人参加网上活动应事先取得其监护人可经查证的同意并遵守《全国青少年网络文明公约》。监护人应承担未成年人网络活动风险及保护未成年人相关网络隐私的首要责任。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.在您签署本协议，完成注册程序时，ALK患者关爱之家会向您提供唯一编号的ALK患者关爱之家账户。您应对您的用户账户、登录密码、验证码的安全以及对通过您的账户实施的行为负责，除非有法律规定或行政司法机关的指令，且征得ALK患者关爱之家的同意，否则您的用户账户不得以任何方式转让、借用、赠与或继承（与账户相关的财产权益除外），您的登录密码和验证码不得对任何第三方提供或泄露，否则，由此给您（或ALK患者关爱之家、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿），ALK患者关爱之家不承担任何责任。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即与ALK患者关爱之家客服联系并通知ALK患者关爱之家暂停或停止提供相关服务。您理解ALK患者关爱之家对您的请求采取行动需要合理时间，ALK患者关爱之家对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        四、ALK患者关爱之家平台服务规范
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.在接受ALK患者关爱之家平台服务的过程中，您不得从事下列行为：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1)发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，包括但不限于病毒、木马、定时炸弹等可能对ALK患者关爱之家系统造成伤害或影响其稳定性的内容制造虚假身份以误导、欺骗他人。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2)传送或散布以其他方式实现传送的含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）：包括版权或商标（或隐私权或公开权），除非用户拥有或控制着相应的权利或已得到所有必要的认可。 
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3)使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本平台获得的图像或相片的资料或信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4)进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账号；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        5)修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        6)在未经ALK患者关爱之家书面明确授权前提下，出售、出租、出借、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.您了解并同意，ALK患者关爱之家有权应政府部门（包括司法及行政部门）的要求，向其提供您在ALK患者关爱之家平台填写的相关必要信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.您了解并同意，为了向您提供有效的服务，ALK患者关爱之家平台可能使用您的终端设备的带宽资源，使用过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.您了解并同意，ALK患者关爱之家平台提供的服务的形式和本质可不经事先通知您而不时变换。相关服务更新或部分服务内容更新后，在可能的情况下，ALK患者关爱之家将以包括但不限于系统提示、公告、站内信等方式提示用户，您有权选择接受更新版本或服务，如您不接受，部分功能将受到限制或不能继续使用。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        5.您了解并同意，您通过使用服务而下载或以其他方式获得的任何材料由您自行作出并承担风险，您将独自对由于下载任何该等材料而导致对电脑系统或其他装置的损害或数据的丢失负责。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        6.您使用ALK患者关爱之家平台服务，即视为您理解并同意以下内容：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1)本平台仅为用户提供医学量表、病情风险评估、定期推送前沿医学研究进展、医疗科普以及其他医学资讯的互联网平台。不实际参与用户的任何研究、实验以及项目等；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2)对于ALK患者关爱之家平台提供的服务，您享有自主选择的权利，但您做出的任何选择及/或决定，均系您依据自身的独立判断做出。本平台不会干涉用户的任何选择及/或决定，亦不对用户的任何选择及/或决定所造成的风险及损害结果承担任何责任。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3)其他因您不当使用本平台服务而导致的任何意外，及其所造成的一切后果均由您本人自行承担，ALK患者关爱之家不承担任何责任。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        7.在ALK患者关爱之家平台上使用ALK患者关爱之家提供的服务过程中，您承诺遵守以下约定：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1)在使用ALK患者关爱之家平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及ALK患者关爱之家平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保ALK患者关爱之家免于因此产生任何损失或增加费用。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2)不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3)不对ALK患者关爱之家平台上的任何数据作商业性利用，包括但不限于在未经ALK患者关爱之家事先书面同意的情况下，以复制、传播等任何方式使用ALK患者关爱之家平台站上展示的资料。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4)不使用任何装置、软件或例行程序干预或试图干预ALK患者关爱之家平台的正常运作或正在ALK患者关爱之家平台上进行的任何活动。您不得采取任何将导致不合理的庞大数据负载加诸ALK患者关爱之家平台网络设备的行动。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        8.您了解并同意：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1)您违反上述承诺时，ALK患者关爱之家有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知于您。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2)根据相关法令的指定或者ALK患者关爱之家平台服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和／或规则的条款的，ALK患者关爱之家有权采取相应措施，包括但不限于删除侵权信息、停止提供服务等。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3)对于您在ALK患者关爱之家平台上实施的行为，包括您未在ALK患者关爱之家平台上实施但已经对ALK患者关爱之家平台及其用户产生影响的行为，ALK患者关爱之家有权单方认定您行为的性质及是否构成对本协议和／或规则的违反，并据此采取相应的处理措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据承担不利后果。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4)对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保ALK患者关爱之家免于承担因此产生的损失或增加的费用。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        5)如您涉嫌违反有关法律或者本协议之规定，使ALK患者关爱之家遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿ALK患者关爱之家因此造成的损失及（或）发生的费用，包括合理的律师费用。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        五、数据保护条款
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.ALK患者关爱之家平台运营方是本网站上呈现的所有信息内容的所有权及知识产权权利人，前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等。同时，ALK患者关爱之家平台运营方对ALK患者关爱之家服务开发和运营等过程中产生的所有数据和信息等享有全部权利。以上权利归属除按照法律法规规定或协议约束应由相关权利方享有权利的内容除外。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.未经ALK患者关爱之家运营方书面许可，您不得自行或授权、允许、协助任何第三人将本网站中信息直接或间接用于其他任何商业目的或用途。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.ALK患者关爱之家平台运营方有权但无义务对您发布的内容进行审核，有权根据相关证据结合《中华人民共和国民法典》、《信息网络传播权保护条例》等法律法规对侵权信息进行处理。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.您在ALK患者关爱之家平台上传或发表的内容，您应保证自身为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，ALK患者关爱之家有权根据实际情况删除相关的内容，且有权追究您的法律责任。给ALK患者关爱之家或任何第三方造成损失的，用户应负责全额赔偿。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        5.您认知并同意，ALK患者关爱之家对服务拥有一切法定权利、所有权和利益，包括存在于服务中的任何知识产权（无论该等权利是否已经登记，也不论该等权利在世界的何等地方存在）。您进一步认知，服务可能包括ALK患者关爱之家指定为保密的信息，未经ALK患者关爱之家事先书面同意，您不得披露该等信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        6.除非您与ALK患者关爱之家另有书面协议，否则本协议中的任何规定均未给予您使用ALK患者关爱之家任何商号、商标、服务标记、标识、域名及其他显著品牌特征的权利。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        7.您同意，您不得删除、掩藏或改动服务所附的或包含的任何专有权利声明（包括著作权和商标声明）。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        六、本协议的终止
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.如果您希望终止使用ALK患者关爱之家产品及服务的，您可以ALK患者关爱之家平台规定的方式注销账号及相关使用信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.发生下列情况时ALK患者关爱之家平台可单方终止与您的服务关系及相关协议约定：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1)您违反了本协议的任何规定（或您的行为方式明确显示您不打算或不能遵守本协议规定）；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2)法律要求ALK患者关爱之家这样做（例如：向您提供服务不合法或变得不合法）
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3)ALK患者关爱之家及/或与ALK患者关爱之家共同向您提供服务的合作伙伴已终止与ALK患者关爱之家的关系或停止提供服务；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4)ALK患者关爱之家认为须立刻终止本协议的其他情形。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.本协议终止时，因您违反本协议约定而须承担的所有责任不受该终止的影响。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        七、责任承担
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.在遵守本协议全部规定的前提下，您明示理解并同意，ALK患者关爱之家不就以下事项对您承担责任：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1)您无论由于何种原因和在任何责任理论项下发生的任何直接、间接、附带、特殊、后果性或惩罚性的损害。这应包括但不限于任何利润损失（无论是直接还是间接发生）、任何商誉或业务声誉损失、任何数据丢失、替代物品或服务的购买费用或其他无形损失；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2)前文所述您可能产生的任何损失或损害，包括但不限于由下列原因导致的损失或损害：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        i.ALK患者关爱之家对服务可能做出的变更，或永久或暂时停止提供服务（或服务中的任何功能）；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        ii.对通过您使用服务而维持或传输的任何内容及其他通信数据的删除、毁坏；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        iii.您未向ALK患者关爱之家提供准确的个人信息；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        iv.您未对您的帐户资料或密码保持安全及保密。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.ALK患者关爱之家不对您发表的回答或评论的正确性进行保证。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.用户在ALK患者关爱之家发表的内容仅表明其个人的立场和观点，并不代表ALK患者关爱之家的立场或观点。用户需自行对所发表内容负责，因所发表内容引发的一切纠纷，由用户自行承担全部法律及连带责任。ALK患者关爱之家不承担任何法律及连带责任。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.ALK患者关爱之家不保证所提供的服务一定能满足用户的全部要求，也不保证服务不会中断，对服务的及时性、安全性、准确性也都不作保证。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        5.对于因不可抗力或ALK患者关爱之家不能控制的原因造成的任何问题，ALK患者关爱之家不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        6.ALK患者关爱之家所提供的任何评估服务和量表服务仅作为健康情况参考，不构成任何诊断意见。用户做出的任何治疗方案的变更都应遵循医嘱。ALK患者关爱之家不对由于患者不遵循医嘱做出的任何行为承担任何责任。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        八、本协议的变更
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.ALK患者关爱之家可不时对通用条款或附加条款作出变更，无须另行通知。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.您理解并同意，如果您在通用条款或附加条款变更日期之后使用服务，则ALK患者关爱之家将把您的使用视为接受更新后的通用条款或附加条款。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        九、一般法律条款
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.本协议未规定的内容请以国家有关法律法规为准，若本协议与国家法律法规规定发生冲突时，以国家法律法规为准。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.本协议及本协议条款项下您与ALK患者关爱之家的关系，受中国法律管辖，但排除其冲突法规定。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.您与ALK患者关爱之家均同意接受位于中国境内的惠每数科(北京)医疗科技有限公司所在地北京有管辖权的人民法院的管辖，以解决任何由本协议引起的法律事项。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.本协议中的条款，请您着重阅读。您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
                        </div>
                    </div>
                    <div className={`${styles.text_gap}`}>
                    </div>
                    </div>
                    :
                    <div className={`${styles.aggreement_content}`}>
                        <div className={`${styles.section}`}>
                        <div className={`${styles.title} ${styles.no_indent}`}>
                            用户隐私政策
                        </div>
                        <div className={`${styles.item}`}>
                        我们尊重并保护所有用户的个人信息安全及隐私权，我们会按照本个人信息保护政策（“本政策”）的规定收集、使用、存储和披露您的个人信息，及按法律法规要求确保您所享有的相关权利，并采取安全保护措施保护您的用户信息安全可控，同时我们也会不时更新本政策。
                        请您在使用我们的各项服务前务必仔细阅读并透彻理解本隐私政策。如果您选择使用或继续使用我们的服务，即意味着同意我们根据本政策的约定处理您的相关信息。如您不同意本政策中的任何内容，您应当立即停止使用我们的服务。如您阅读完后有任何问题，您可以通过邮件leo.chen@huimeihealth.com.cn反馈渠道联系我们，我们会尽快为您作出解答。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        (一) 信息的收集使用规则
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.我们收集哪些您的个人信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)在您使用我们的服务的过程中，我们会获取您通过微信订阅我们小程序的信息，但是我们不会采集您的任何个人隐私信息，包括但不限于您的微信头像、昵称、姓名、手机号等信息；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (2)为向您提供上述服务，我们可能会调用您设备中的访问及使用权限。在您使用相应功能时会看到弹窗提醒，询问您是否授权，您也可以在设备的设置功能中选择关闭部分或全部权限。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (3)为了您可以正确使用工具，首次使用工具时，需要您阅读和同意用户需知。我们会记录您是否阅读并同意了用户需知，以便您可以更加准确的使用我们的工具；
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (4)我们将会在本政策所涵盖的用途内使用收集的信息。个人信息的处理目的、处理方式和处理的个人信息种类发生变更时，我们将重新取得您的同意。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.我们如何使用您的个人信息
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)我们严格遵守法律法规的规定及与用户的约定，将收集的信息按照本政策的规定用于以下用途。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        ① 提供、维护及优化本程序服务：我们会利用收集的信息来提供和优化改进本程序服务，
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        ② 安全保障：我们会利用相关信息协助提升本程序服务的安全性和可靠性，包括检测、防范和应对可能危害用户或公众的欺诈行为、滥用行为、非法行为、安全风险和技术问题等。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        ③为了遵从相关法律法规、部门规章、政府指令的相关要求。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.如果需要从第三方间接获取您的个人信息，我们会在获取前向您告知个人信息的来源、类型及使用范围，如我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您该等个人信息前征得您的授权同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保证其提供的信息的合法性。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        (二) 信息的存储
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.我们会通过安全的方式存储您的信息，为最大程度保护您的个人隐私，当前工具仅进行本地缓存保存，未进行任何服务器数据存储。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.请您注意，如您选择注销您的账户，我们会删除您的信息或对其进行匿名化处理，但相关法律法规规定必须在一定期间内留存的信息除外。对于上述必须留存的信息，我们会在法律法规规定的留存期间到期后删除或进行匿名化处理。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.我们会采取合理可行的措施，尽力避免收集无关的用户信息。除非法律允许或经另行约定，我们只会在达成本政策所述目的所需的期限内保留您的用户信息。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.如出现本程序产品和服务停止运营的情况，我们会采取合理措施保护您用户信息安全，保护及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        5.我们将收集到的您的用户信息存放在中华人民共和国境内，如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们将向您说明具体情况并取得您的同意并按照中国法律法规的要求完成相应的安全评估。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        (三) 信息安全保护
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门的要求，上报用户信息安全事件的处置情况。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        (四) 信息的共享、转让、公开披露
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.共享
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (2)为提升您的用户体验，我们可能需要向第三方合作伙伴等分享已经匿名化或去标识化处理后的信息，我们将要求其严格遵守我们关于数据保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (3)我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.转让
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)在获取明确同意的情形下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (2)在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求承接持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.公开披露
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)我们仅会获取你对我们小程序工具的订阅信息，对于订阅信息我们严格保密，以下情况除外：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        ① 获得您明确同意后。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        ② 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2）除上述情形外，我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        (五) 您的权利
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.您可以通过微信小程序的删除功能删除我们工具，删除后并且清空微信缓存的情况下，您使用我们小程序的所有数据和记录将被彻底删除。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.在以下情形中，您可以向我们提出删除用户信息的请求：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)如果我们处理用户信息的行为违反法律法规。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (2)如果我们收集、使用您的用户信息，却未征得您的明确同意。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (3)我们停止对您提供服务。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        为保障安全，您可能需要提供书面请求，或以其他方式证明您的用户身份，我们可能会先要求验证自己的身份，然后再处理您的请求。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        3.改变授权范围：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)改变或撤回敏感信息权限：您可以在设备本身操作系统中关闭地理位置、摄像头等权限改变同意范围或撤回您的授权。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (2)拒绝接受推送及营销信息：您可以在电话中明确表示拒绝或通过手机设置关闭“推送通知”。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (3)请您理解，特定的业务功能和服务将需要您的信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        4.对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定的成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。在以下情形中，按照法律法规的要求，我们将无法响应您的请求：
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (1)与我们履行法律法规规定的义务相关的。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (2)与国家安全、国防安全直接相关的。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (3)与公共安全、公共卫生、重大公共利益直接相关的。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (4)与刑事侦查、起诉、审判和判决等直接相关的。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (5)我们有充分证据表明您存在主观恶意或滥用权利的。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (6)响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        (7)涉及商业秘密的。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                        (六)个人信息保护政策变更 
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        1.当前版本的个人信息保护政策更新日期为2022年3月22日起正式生效。
                        </div>
                        <div className={`${styles.item} ${styles.no_indent}`}>
                        2.当本政策的条款发生变更时，我们会在版本更新时以适当的方式向您提示变更后的个人信息保护政策，并向您说明生效日期。请您仔细阅读变更后的本政策内容，您继续使用我们的产品或服务即表示您同意我们按照更新后的本政策处理您的个人信息。
                        </div>
                        </div>
                        <div className={`${styles.text_gap}`}></div>
                    </div>
                }
            </div>
        </div>
    )

}

export default Privacy;